module.exports = __webpack_public_path__ + "img/ResidentSupervise1.dd2eb0db.png";